import CompanyList from "./CompanyList";
import PhoneList from "./PhoneList";
import RoleList from "./RoleList";
import UserList from "./UserList";
import UserHistoryList from "./UserHistoryList";
import CompanyHistoryList from "./CompanyHistoryList";
import UserFormPage from "./UserFormPage"

const routes = [
    {path : 'administration/company/list', component: () => <CompanyList/>, isPublic : false, isSidebar : true, permissions:['view_organizations']},
    {path : 'administration/phone/list', component: () => <PhoneList/>, isPublic : false, isSidebar : true, permissions:['view_phones']},
    {path : 'administration/user/list', component: () => <UserList/>, isPublic : false, isSidebar : true, permissions:['view_users']},

    {path : 'administration/user/create', component: () => <UserFormPage/>, isSidebar : true, isPublic : false , permissions:['add_user']},
    {path : 'administration/user/update', component: (data,type) => <UserFormPage data={data} type={type}/>, isSidebar : true, isPublic : false ,permissions:['update_user']},
    
    {path : 'administration/role/list', component: () => <RoleList/>, isPublic : false, isSidebar : true, permissions:['view_roles']},
    {path : 'administration/user/logs', component: (data) => <UserHistoryList data={data} />, isPublic : false, isSidebar : true, permissions:['view_users']},
    {path : "administration/company/logs", component: (data) => <CompanyHistoryList data={data} />, isPublic: false, isSidebar: true, permissions:["view_organizations"]},
]

export default routes;
